import { SVGProps, Ref, forwardRef } from 'react';

export const TrolleybusFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 13.787c0 .822 0 1.233-.176 1.54-.118.208-.29.38-.497.498-.307.175-.719.175-1.54.175-.735 0-1.102 0-1.39-.15a1.33 1.33 0 0 1-.487-.43c-.133-.194-.193-.44-.25-.84-.753.065-1.633.09-2.66.09s-1.907-.025-2.66-.09c-.058.4-.117.646-.25.84a1.34 1.34 0 0 1-.487.43c-.289.15-.655.15-1.39.15-.821 0-1.233 0-1.54-.175a1.33 1.33 0 0 1-.497-.498C1 15.02 1 14.61 1 13.787V8.6h14zM4.532 10a.934.934 0 1 0 .002 1.867A.934.934 0 0 0 4.532 10m6.93 0a.933.933 0 1 0 .002 1.866.933.933 0 0 0-.001-1.866M6.47 11.634h3.06v-1.4H6.47z"
            fill="currentColor"
        />
        <path
            d="M4.445 1.697c.42-.068.888-.114 1.412-.145L5.442 0H6.89l.403 1.506Q7.634 1.5 8 1.5c5.796 0 6.887.737 6.987 5.7H1.013c.06-2.997.483-4.451 2.084-5.135L2.544 0h1.447z"
            fill="currentColor"
        />
    </svg>
));
TrolleybusFilledSize16Glyph.displayName = 'TrolleybusFilledSize16Glyph';
